export default __webpack_public_path__ + "static/media/ps_03.b8af5516.png";